import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import FeatureSection from '../components/FeatureSection';
import Categories from '../components/Categories';
import Features3 from '../components/Features3';
import ProductGrid from '../components/ProductGrid';
import Marquee from '../components/Marquee';
import CryptoBanner from '../components/CryptoBanner';
import { api } from '../api/client';

const Home = () => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.listProducts({ published: true }).then(setProducts).catch(() => {});
  }, []);

  const fifteen = products.find((p) => p.category === '15k') || products[0];
  const twenty = products.find((p) => p.category === '20k') || products[1];

  return (
    <>
      <Header />
      <main>
        <Hero />
        <CryptoBanner />
        {fifteen && (
          <FeatureSection
            eyebrow="15K Tornado"
            title="Discover the 15K Tornado Vape by RandM Fumot — Now Available at WeSupplySmoke."
            body="Experience vaping on a whole new level with the RandM Fumot 15K Tornado, one of the most advanced and flavorful disposable vapes on the market. Designed for users who want maximum performance, stunning design, and long-lasting satisfaction, the Tornado 15K delivers up to 15,000 puffs of smooth, consistent vapor."
            bullets={['Up to 15,000 puffs', 'Mesh coil for rich flavor', 'USB-C rechargeable', 'Adjustable airflow', 'Ready out of the box']}
            cta={{ label: 'Shop 15K Tornado', href: '/shop?cat=15k' }}
            image={fifteen.image}
          />
        )}
        {twenty && (
          <FeatureSection
            reverse
            eyebrow="20K Tornado"
            title="Unleash the Power: 20K Tornado Vape by RandM Fumot."
            body="Step up your vaping game with the RandM Fumot 20K Tornado, the ultimate choice for vapers who demand long-lasting performance and unbeatable flavor. With up to 20,000 puffs, this device is built for serious enthusiasts who want reliability, style, and convenience in one sleek package."
            bullets={['Up to 20,000 puffs', 'Mesh coil technology', 'USB-C rechargeable', 'Adjustable airflow', 'Prefilled & hassle-free']}
            cta={{ label: 'Shop 20K Tornado', href: '/shop?cat=20k' }}
            image={twenty.image}
          />
        )}
        <Categories />
        <Features3 />
        <ProductGrid heading="Featured Drops" limit={8} products={products.slice(0, 8)} />
        <Marquee />
      </main>
      <Footer />
    </>
  );
};

export default Home;
